export default __webpack_public_path__ + "static/sfx-bg_1-a1c95a76587c001e019493f009396090.png";